import React from "react";
import { CloseIconButton, CloseVideoButton, PlayVideoBox, SendbirdVideoModal } from "../chatStyled";


export interface DialogProps {
  open: boolean;
  videoUrl?: string;
  imageUrl?: string;
  iframeSrc?: string;
  onClose: (value: string) => void;
  isMobile?: boolean;
}

const PlayVideoModal: React.FC<DialogProps> = (props) => {
    const { onClose, open, videoUrl, imageUrl, iframeSrc, isMobile } = props;

    const handleClose = () => {
        onClose("");
    };

    const handleListItemClick = (value: string) => {
        onClose("");
    };

    return(
        <SendbirdVideoModal fullScreen={isMobile} onClose={handleClose} open={open}>
            <CloseIconButton onClick={handleClose}>
                <img src="https://members.performancegolf.com/wp-content/themes/pgm/dist/images/icons/closeNew.svg" alt="Close" />
            </CloseIconButton>
            <PlayVideoBox>
                {iframeSrc &&
                <iframe
                    src={iframeSrc}
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                />}
                {!iframeSrc && videoUrl &&
                <video controls autoPlay playsInline>
                    <source src={videoUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>}
                {!iframeSrc && !videoUrl && imageUrl &&
                <img
                    src={imageUrl}
                    alt=""
                    style={{ width: 'calc(100% - 50px)', height: 'auto', display: 'block', borderRadius: '9px' }}
                />}
                <CloseVideoButton onClick={handleClose}>Close</CloseVideoButton>
            </PlayVideoBox>
        </SendbirdVideoModal>
    )
};

export default PlayVideoModal;